import React, { ReactNode, useEffect } from "react";
import { Box, HStack, Image } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { SessionMenu } from "./SessionMenu";
import { Notifications } from "../../../notification/views/Notifications";
import { useStores } from "../../stores/RootStore";
import { Link } from "react-router-dom";
import { appRoutes } from "../../../../App";
import logo from "@keita/lanepatrol-sdk/assets/logo/logo-vertical.png";

export const headerHeight = "60px";

const AppHeaderBase: React.FC<{ children?: ReactNode }> = ({
  children = null,
}) => {
  const { accountStore, authStore } = useStores();

  useEffect(() => {
    if (authStore.userEmail) {
      accountStore.fetchUserAccounts();
    }
    // eslint-disable-next-line
  }, [authStore.userEmail]);

  return (
    <HStack
      px={6}
      height={headerHeight}
      bg="white"
      position="fixed"
      top={0}
      left={0}
      right={0}
      boxShadow="0px 2px 6px -4px rgba(0, 0, 0, 0.5)"
      zIndex="docked"
    >
      {children ?? (
        <HStack px={4} flexGrow={1}>
          <AppHeaderLogo />
        </HStack>
      )}
      {authStore.isAuthenticated && (
        <>
          <Notifications />
          <SessionMenu email={authStore.userEmail ?? "..."} />
        </>
      )}
    </HStack>
  );
};

export const AppHeader = observer(AppHeaderBase);

export const AppHeaderHeight: React.FC = () => (
  <Box height={headerHeight} flexShrink={0} />
);

export const AppHeaderLogo = () => (
  <Link to={appRoutes.home()}>
    <Image height="40px" src={logo} alt="Logo" />
  </Link>
);
